import React, { useState, useEffect } from 'react';

// Wire'a çift tıklanınca açılan etiket tipi seçim menüsü (bundle için: Bundle Menüsü).
// Sürüklenebilir, Esc ile kapanır. Bundle modunda hatların panel/numara listesini gösterir.
export default function WireLabelMenu({ x: initX, y: initY, previews, isBundleRep, allWiresSingleEdge, wireInfos, wireCount, initialVisualWireCount, onSelect, onUnbundle, onScaleBundle, onClose }) {
  const [pos, setPos] = useState({ x: initX, y: initY });
  const [vc, setVc] = useState(initialVisualWireCount ?? wireCount ?? 2);
  const stop = e => e.stopPropagation();

  // Esc → kapat
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  // Header sürükleme
  const onHeaderMouseDown = e => {
    e.stopPropagation();
    const startX = e.clientX - pos.x;
    const startY = e.clientY - pos.y;
    const onMove = ev => setPos({ x: ev.clientX - startX, y: ev.clientY - startY });
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp, { capture: true });
    };
    document.addEventListener('mousemove', onMove);
    // capture:true — container'daki onMouseUp stopPropagation'ından etkilenmez
    document.addEventListener('mouseup', onUp, { capture: true });
  };

  const items = [
    { key: 'numara', label: 'Numara' },
    { key: 'panoNo', label: 'Pano no ile' },
    { key: 'bundle', label: 'Bundle aralığı' },
  ];

  return (
    <div
      onMouseDown={stop}
      onMouseUp={stop}
      onClick={stop}
      style={{
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        zIndex: 100000,
        background: 'rgba(20,30,40,0.95)',
        color: '#aff',
        border: '1px solid #0aa',
        borderRadius: 4,
        padding: 6,
        font: '12px/1.3 "Segoe UI", sans-serif',
        boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
        minWidth: 200,
        userSelect: 'none',
      }}
    >
      {/* Sürüklenebilir başlık */}
      <div
        onMouseDown={onHeaderMouseDown}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 6,
          cursor: 'grab',
          paddingBottom: 4,
          borderBottom: '1px solid rgba(0,170,170,0.3)',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{isBundleRep ? 'Çoklu Hatlar' : 'Etiket ekle'}</span>
        <button
          onMouseDown={e => e.stopPropagation()}
          onClick={onClose}
          style={{ background: 'none', border: 'none', color: '#aff', cursor: 'pointer', fontSize: 14, lineHeight: 1 }}
          title="Kapat (Esc)"
        >×</button>
      </div>

      {/* Bundle: Bundle'ı Çöz */}
      {isBundleRep && (
        <div
          onClick={onUnbundle}
          style={{
            padding: '5px 8px',
            cursor: 'pointer',
            borderRadius: 3,
            color: '#f88',
            fontWeight: 600,
            marginBottom: 4,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,100,100,0.2)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
        >
          ✕ Bundle'ı Çöz
        </div>
      )}

      {/* Bundle: görsel genişlik slider — panel çıkış hatları tek kenarlıysa (2 vertex) */}
      {isBundleRep && wireCount > 2 && allWiresSingleEdge && (
        <div style={{ padding: '4px 8px 6px', borderBottom: '1px solid rgba(0,170,170,0.2)', marginBottom: 4 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
            <span style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Görsel Genişlik</span>
            <span style={{ color: '#fc8', fontFamily: 'monospace', fontSize: 11 }}>{vc} / {wireCount}</span>
          </div>
          <input
            type="range"
            min={2}
            max={wireCount}
            value={vc}
            onChange={e => { const v = Number(e.target.value); setVc(v); onScaleBundle?.(v); }}
            onMouseDown={e => e.stopPropagation()}
            onMouseUp={e => e.stopPropagation()}
            style={{ width: '100%', cursor: 'pointer', accentColor: '#0aa' }}
          />
        </div>
      )}

      {/* Bundle: hat listesi — pano bazında gruplu */}
      {isBundleRep && wireInfos && wireInfos.length > 0 && (() => {
        // panelName'e göre grupla, sırası korunsun
        const groups = [];
        const keyIndex = new Map();
        for (const info of wireInfos) {
          const key = info.panelName || '—';
          if (!keyIndex.has(key)) {
            keyIndex.set(key, groups.length);
            groups.push({ panelName: key, numbers: [] });
          }
          if (info.wireNumber != null) groups[keyIndex.get(key)].numbers.push(info.wireNumber);
        }
        return (
          <div style={{ marginBottom: 6, borderBottom: '1px solid rgba(0,170,170,0.2)', paddingBottom: 4 }}>
            {groups.map(g => (
              <div key={g.panelName} style={{ padding: '2px 8px', display: 'flex', gap: 6, alignItems: 'baseline' }}>
                <span style={{ color: '#8df', fontWeight: 600, flexShrink: 0 }}>{g.panelName}</span>
                <span style={{ color: '#fc8', fontFamily: 'monospace', fontSize: 11 }}>
                  {g.numbers.sort((a, b) => a - b).join(', ') || '—'}
                </span>
              </div>
            ))}
          </div>
        );
      })()}

      {/* Etiket seçenekleri */}
      <div style={{ fontSize: 11, color: '#888', padding: '2px 8px 4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        Etiket ekle
      </div>
      {items.map(it => {
        const preview = previews?.[it.key];
        const enabled = preview != null;
        return (
          <div
            key={it.key}
            onClick={() => enabled && onSelect(it.key)}
            style={{
              padding: '5px 8px',
              cursor: enabled ? 'pointer' : 'not-allowed',
              opacity: enabled ? 1 : 0.4,
              borderRadius: 3,
              display: 'flex',
              justifyContent: 'space-between',
              gap: 12,
            }}
            onMouseEnter={e => { if (enabled) e.currentTarget.style.background = 'rgba(0,170,170,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          >
            <span>{it.label}</span>
            <span style={{ color: '#fc8', fontFamily: 'monospace' }}>
              {preview != null ? preview : '—'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
